import axios from "axios";


let baseHeaders = {
    'Access-Control-Allow-Origin': '*',
    'application': 'x-www-form-urlencoded',
    'Content-type': 'application/json',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Origin, Cache-Control, Pragma, Authorization, Accept, Accept-Encoding',
    'Access-Control-Allow-Methods': 'PUT, POST, GET, OPTIONS, DELETE'
}

let baseHeaders2 = {
    'Content-type': 'application/json'
}


const test = 'http://localhost:3000'
const baseURL = process.env.REACT_APP_API //'http://localhost:3000'


export const getCurrentUser = () => {
    const userStr = localStorage.getItem("user");
    if (userStr) return JSON.parse(userStr);
    else return null;
};

export const getInfoUser = async (token: string, email: string) => {

    let response = await fetch(`${baseURL}/accounts/get/user`, {
        method: 'POST',
        body: JSON.stringify({ "token": token, data: { token: token, email: email } }),
        headers: baseHeaders
    });

    return response.json()
}

export const getCardsUser = async (token: string, email: string, countryCode: string) => {

    let userCardsReponse
    await axios.post(`${baseURL}/accounts/get/cardsUser`, {
        "token": token,
        "data": {
            "email": email,
            "countryCode": countryCode,
        }
    },
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    ).then((response) => {
        userCardsReponse = response.data;
        
    }).catch((error) => {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
        }
        return null;
    });

    return userCardsReponse;
};

export const postAddCardAccount = async (token: string, account: string, countryCode: string, cardName: string, cardNumber: string, cardExpDate: string, cardCvv: string) => {


    try {
        const response = await axios({
            method: 'POST',
            url: `${baseURL}/accounts/create/newCard`,
            headers: baseHeaders,
            data: { token: account, country: countryCode, card: cardNumber, expiration: cardExpDate, cvv: cardCvv, cardHolder: cardName, cardColor: "Azul" }
        });


        if (response.status === 200) {
            //console.log(response);

            return { status: response.status, data: response.data }
        }

    } catch (error) {

        return { status: 500 }
    }


}

export const deleteCardAccount = async (token: string, account: string, cardId: [any]) => {
    try {
        const response = await axios({
            method: 'DELETE',
            url: `${baseURL}/accounts/delete/deleteUserCard`,
            headers: baseHeaders,
            data: { "token": token, data: { email: account, card: cardId } }
        });


        if (response.status === 200) {
            return response.data
        }
        return response
    } catch (error) {
        //console.log("error deleteCardAccount = ", error)
    }

};




// recuperar E-Ticket de la cuenta del usuario
export const getETicketAccount = async (token: string, countryCode: string) => {
    let response = await fetch(`${baseURL}/service/orders/get/number/orderByAccountETicket`, {
        //  let response = await fetch(`http://localhost:3000/service/orders/get/number/orderByAccountETicket`, {
            method: 'POST',
        body: JSON.stringify({ "token": token, data: { account: token, countryCode: countryCode } }),
        headers: baseHeaders
    });

    
    return response.json()
}

